<template>
  <div class="space-y-4 animate-fade-in">
    <h3 class="text-xl text-white">My Equipment Out</h3>
    <p class="text-slate-400 text-sm">All items currently checked out to you.</p>
    <div class="flex flex-wrap gap-6 justify-start">
      <div
        v-for="item in items"
        :key="item.id"
        class="panel-neo panel-neo--glassier glass-anim p-6 w-[320px] max-w-[320px]"
      >
        <h4 class="text-white font-semibold">{{ item.name }}</h4>
        <p class="text-slate-400 text-sm">{{ item.serial }}</p>
        <p class="text-slate-500 text-xs mt-1">Due: {{ formatDate(item.due_at) }}</p>
        <div class="mt-4 inline-flex rounded-lg overflow-hidden border border-slate-700">
          <router-link to="/equipment" class="px-3 py-1 bg-slate-900 text-white">Open</router-link>
          <button
            class="px-3 py-1 btn-primary border-l border-slate-700"
            @click="openCheckIn(item)"
          >
            Check In
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { supabase } from '@/lib/supabaseClient'

const items = ref<any[]>([])

async function load() {
  const { data } = await supabase.rpc('current_user_checkouts_v')
  items.value = data || []
}

function openCheckIn(item: any) {
  // This will be handled by App-level modal later
  window.dispatchEvent(new CustomEvent('open-checkin', { detail: item }))
}

function formatDate(s?: string) {
  if (!s) return '-'
  return new Date(s).toLocaleDateString()
}

onMounted(load)
</script>
